import { MODAL_OPEN, MODAL_CLOSE, IModalPayload } from 'redux/reducers/modalReducer';

export const openModal = (modalSet: IModalPayload) => ({
  type: MODAL_OPEN,
  payload: modalSet,
});

export const closeModal = () => ({
  type: MODAL_CLOSE,
});
